import { ORPCError } from "@orpc/client";

/**
 * The body the API answered an error with.
 *
 * The API's guards reply outside oRPC with a plain `{ statusCode, errorCode }`
 * body, which the oRPC client wraps in the error's `data.body`. Checks such as
 * `isPaladinApiError` look for those fields, so they need this body rather than
 * the `ORPCError` around it.
 */
export function apiErrorBody(error: unknown): unknown {
  if (!(error instanceof ORPCError)) {
    return error;
  }

  const data: unknown = error.data;

  return typeof data === "object" && data !== null && "body" in data
    ? data.body
    : error;
}
